var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAllInOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0L40 10V0H30ZM40 30L30 40H40V30ZM10 40L0 30V40H10ZM0 10L10 0H0V10ZM32.375 7.625C25.55 0.8 14.45 0.8 7.625 7.625C0.8 14.45 0.8 25.55 7.625 32.375C14.45 39.2 25.55 39.2 32.375 32.375C39.2 25.55 39.2 14.475 32.375 7.625ZM29.625 29.625C24.3 34.95 15.7 34.95 10.375 29.625C5.05 24.3 5.05 15.7 10.375 10.375C15.7 5.05 24.3 5.05 29.625 10.375C34.95 15.7 34.95 24.3 29.625 29.625Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllInOne);
export default __webpack_public_path__ + "static/media/icon-all-in-one.c9a1ff4ce67ad59a731e3d76dfec7c7c.svg";
export { ForwardRef as ReactComponent };